import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

const uiStateName = "inspector-panel-ui-v1"

type UIState = {
    // ID of export option (typically a link) being copied.
    copyingExportId?: string
}

const initialState: UIState = {}

const root = (state: RootState) => state[uiStateName] as UIState

const {
    reducer,
    actions: { setCopyingExportId },
} = createSlice({
    name: uiStateName,
    initialState,
    reducers: {
        setCopyingExportId: (state, action: { payload: string | undefined }) => {
            state.copyingExportId = action.payload
        },
    },
})

export const selectCopyingExportId = createSelector([root], (state) => state.copyingExportId)

export { setCopyingExportId }

export const uiReducer = { [uiStateName]: reducer }
